var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202.173,
    height: 60,
    viewBox: "0 0 202.173 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.849,
    y1: 0.31,
    x2: 0.361,
    y2: 0.799,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.97,
    y1: 0.436,
    x2: -1.177,
    y2: 0.436,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.761,
    y1: 0.213,
    x2: -0.443,
    y2: 1.411,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.17,
    y1: -0.275,
    x2: 0.367,
    y2: 0.26,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.624,
    y1: 0.038,
    x2: -0.364,
    y2: 1.027,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc2e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c0e4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 5.233,
    y1: -7.998,
    x2: -1.121,
    y2: -1.634,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#008de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00a7e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00b8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00c4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.943,
    y1: -0.195,
    x2: -2.414,
    y2: -0.195,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0c500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#e0a600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#e09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.944,
    y1: 0.999,
    x2: -2.414,
    y2: 0.999,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffce40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#ffbc40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 5.219,
    y1: 0.865,
    x2: -1.113,
    y2: 6.933,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40b8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#40b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#40ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40eaff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -0.137,
    y1: -0.184,
    x2: 0.304,
    y2: 0.257,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65b895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#62bd95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#50db97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#44ed98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40f498"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.685,60H7.488A7.516,7.516,0,0,1,0,52.5V7.5A7.516,7.516,0,0,1,7.488,0h187.2a7.516,7.516,0,0,1,7.488,7.5v45a7.516,7.516,0,0,1-7.488,7.5",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.685,0H7.488A7.516,7.516,0,0,0,0,7.5v45A7.516,7.516,0,0,0,7.488,60h187.2a7.516,7.516,0,0,0,7.488-7.5V7.5A7.516,7.516,0,0,0,194.685,0m0,1.2a6.3,6.3,0,0,1,6.29,6.3v45a6.3,6.3,0,0,1-6.29,6.3H7.488A6.3,6.3,0,0,1,1.2,52.5V7.5a6.3,6.3,0,0,1,6.29-6.3h187.2",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M927.71,157.831a4.066,4.066,0,0,1-1.116,3,4.354,4.354,0,0,1-3.3,1.332,4.7,4.7,0,1,1,0-9.4,4.627,4.627,0,0,1,1.844.377,3.7,3.7,0,0,1,1.405,1.005l-.79.792a3.032,3.032,0,0,0-2.46-1.068,3.595,3.595,0,1,0,2.51,6.185,2.833,2.833,0,0,0,.753-1.823h-3.263v-1.081h4.354a3.853,3.853,0,0,1,.063.679",
    transform: "translate(-856.697 -142.466)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M925.639,155.756h-.15a3.914,3.914,0,0,1-1.072,2.9h0a4.2,4.2,0,0,1-3.193,1.286,4.551,4.551,0,1,1,0-9.1,4.481,4.481,0,0,1,1.785.365,3.561,3.561,0,0,1,1.35.965l.115-.1-.106-.106-.79.792.106.105.115-.1a3.186,3.186,0,0,0-2.575-1.122,3.745,3.745,0,1,0,2.615,6.441,2.986,2.986,0,0,0,.8-1.916l.014-.163h-3.276v-.781h4.2v-.15l-.148.026a3.664,3.664,0,0,1,.06.653h.3a3.987,3.987,0,0,0-.065-.706l-.022-.123h-4.629v1.381h3.413v-.15l-.149-.013a2.688,2.688,0,0,1-.71,1.73,3.425,3.425,0,0,1-4.754,0,3.622,3.622,0,0,1,0-4.976,3.26,3.26,0,0,1,2.35-.957,2.882,2.882,0,0,1,2.345,1.014l.105.125.9-.908.1-.1-.089-.105a3.849,3.849,0,0,0-1.461-1.047,4.776,4.776,0,0,0-1.9-.39,4.851,4.851,0,1,0,0,9.7,4.507,4.507,0,0,0,3.409-1.378l-.108-.1.106.106a4.218,4.218,0,0,0,1.16-3.11h-.15m6.9-3.759H928.45v2.854h3.69v1.081h-3.69v2.854h4.092v1.106H927.3v-9h5.246V152",
    transform: "translate(-854.627 -140.391)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.142,154.786v-.15H1076.9v3.154h3.69v.781h-3.69v3.154h4.092v.806h-4.946v-8.7h4.946v.956h.15v0h.15V153.53h-5.545v9.3h5.545v-1.406H1077.2v-2.554h3.69v-1.381h-3.69v-2.554h4.092v-.15h-.15m4.869,7.894h-1.156v-7.894h-2.51V153.68h6.175v1.106h-2.51v7.894",
    transform: "translate(-1003.227 -143.18)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.238,162.68v-.15h-1.006v-7.894h-2.51v-.806h5.875v.806h-2.51v8.044h.15v0h.15v-7.744h2.51V153.53h-6.474v1.406h2.51v7.894h1.455v-.15h-.15m6.977,0v-9h1.154v9h-1.154",
    transform: "translate(-1092.453 -143.18)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1329.439,162.68h.15v-8.85h.854v8.7h-1v.15h0v.15h1.3v-9.3h-1.454v9.3h.15v-.15m6.276,0h-1.155v-7.894h-2.509V153.68h6.174v1.106h-2.51v7.894",
    transform: "translate(-1239.677 -143.18)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.829,161.966v-.15h-1.006v-7.894h-2.509v-.806h5.875v.806h-2.51v8.044h.149v0h.15v-7.744h2.509v-1.406h-6.474v1.406h2.51v7.894h1.455v-.15h-.15m8.463-1.916a3.452,3.452,0,0,0,4.882,0,3.84,3.84,0,0,0,0-5.167,3.452,3.452,0,0,0-4.882,0,3.845,3.845,0,0,0,0,5.167Zm5.736.753a4.66,4.66,0,0,1-6.588,0,4.866,4.866,0,0,1,0-6.674,4.644,4.644,0,0,1,6.583.006,4.853,4.853,0,0,1,.006,6.668Z",
    transform: "translate(-1275.792 -142.466)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1517.954,157.974l-.106.105a3.6,3.6,0,0,0,5.095,0,3.989,3.989,0,0,0,0-5.378,3.6,3.6,0,0,0-5.095,0,3.994,3.994,0,0,0,0,5.378l.106-.105.106-.105a3.695,3.695,0,0,1,0-4.956,3.3,3.3,0,0,1,4.669,0,3.692,3.692,0,0,1,0,4.956,3.3,3.3,0,0,1-4.669,0Zm5.736.753-.107-.1a4.511,4.511,0,0,1-6.374,0l0,0,0,0a4.719,4.719,0,0,1,0-6.465,4.5,4.5,0,0,1,6.368.006,4.7,4.7,0,0,1,.006,6.459l.107.1.108.1a5,5,0,0,0-.006-6.876,4.793,4.793,0,0,0-6.8-.006h0a5.02,5.02,0,0,0,0,6.884l0,0,0,0a4.809,4.809,0,0,0,6.8,0Zm2.944,1.163v-9h1.405l4.367,7h.05l-.05-1.734v-5.267h1.155v9h-1.205l-4.569-7.341h-.05l.05,1.735v5.606h-1.154",
    transform: "translate(-1413.454 -140.391)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M963.453,162.68h.15v-8.85h1.172l4.367,7h.287l-.054-1.887V153.83h.856v8.7h-.972l-4.569-7.341H964.4l.054,1.887v5.453h-1v.15h0v.15h1.3v-5.758l-.05-1.737-.15,0v.15h.05v-.15l-.127.08,4.613,7.411h1.438v-9.3h-1.455v5.419l.05,1.737.15,0v-.15h-.05v.15l.127-.08-4.411-7.072H963.3v9.3h.15v-.15m46.965,25.5h2.795V169.428h-2.795Zm25.17-12-3.2,8.13h-.1l-3.325-8.13h-3.01l4.986,11.363-2.843,6.321h2.916l7.683-17.684Zm-15.847,9.867c-.917,0-2.193-.458-2.193-1.593,0-1.447,1.59-2,2.962-2a4.967,4.967,0,0,1,2.553.628A3.39,3.39,0,0,1,1019.741,186.05Zm.337-10.277a5.245,5.245,0,0,0-4.986,2.871l2.48,1.037a2.647,2.647,0,0,1,2.553-1.375,2.692,2.692,0,0,1,2.938,2.413v.193a6.172,6.172,0,0,0-2.914-.724c-2.673,0-5.4,1.471-5.4,4.222,0,2.509,2.192,4.126,4.648,4.126a3.943,3.943,0,0,0,3.566-1.833h.1v1.447h2.7v-7.19C1025.761,177.631,1023.281,175.773,1020.078,175.773Zm-17.27,2.693h-3.975v-6.428h3.975a3.214,3.214,0,1,1,0,6.428Zm-.072-9.037h-6.7V188.18h2.793v-7.1h3.9a5.832,5.832,0,1,0,0-11.647Zm-36.513,16.625a3.881,3.881,0,0,1,0-7.733,3.9,3.9,0,0,1,0,7.733Zm3.209-8.821h-.1a4.411,4.411,0,0,0-3.354-1.426,6.386,6.386,0,0,0,0,12.759,4.341,4.341,0,0,0,3.354-1.45h.1v.918c0,2.441-1.3,3.746-3.4,3.746a3.527,3.527,0,0,1-3.209-2.272l-2.436,1.015a6.07,6.07,0,0,0,5.646,3.77c3.281,0,6.056-1.934,6.056-6.646V176.194h-2.654Zm4.584,10.947h2.8V169.428h-2.8Zm6.924-6.186a3.5,3.5,0,0,1,3.329-3.721,2.463,2.463,0,0,1,2.364,1.354Zm8.686-2.126a5.921,5.921,0,0,0-5.453-4.06,6.058,6.058,0,0,0-6.007,6.38,6.238,6.238,0,0,0,6.321,6.38,6.334,6.334,0,0,0,5.308-2.827l-2.172-1.45a3.636,3.636,0,0,1-3.137,1.764,3.24,3.24,0,0,1-3.088-1.933l8.516-3.528Zm-67.852-2.1v2.706h6.466a5.652,5.652,0,0,1-1.472,3.407,6.612,6.612,0,0,1-4.994,1.982,7.2,7.2,0,0,1,0-14.4,6.885,6.885,0,0,1,4.873,1.933l1.906-1.909a9.417,9.417,0,0,0-6.779-2.731,9.909,9.909,0,1,0,0,19.816,8.762,8.762,0,0,0,9.24-9.11,8.785,8.785,0,0,0-.145-1.692Zm16.591,8.289a3.877,3.877,0,1,1,3.595-3.867A3.688,3.688,0,0,1,938.365,186.054Zm0-10.246a6.38,6.38,0,1,0,6.393,6.38A6.283,6.283,0,0,0,938.365,175.807Zm13.947,10.246a3.877,3.877,0,1,1,3.595-3.867A3.688,3.688,0,0,1,952.312,186.054Zm0-10.246a6.38,6.38,0,1,0,6.394,6.38A6.283,6.283,0,0,0,952.312,175.807Z",
    transform: "translate(-850.273 -143.18)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M222.344,162.621a2.9,2.9,0,0,0-.8,2.217v32.736a3.007,3.007,0,0,0,.693,2.108l.111.107h0a1.923,1.923,0,0,0,1.323.488,3.446,3.446,0,0,0,1.678-.5L247.084,187.4l7.467-4.25a2.8,2.8,0,0,0,1.57-1.945v0a2.794,2.794,0,0,0-1.57-1.946l-7.467-4.249-21.737-12.371a3.452,3.452,0,0,0-1.681-.5,1.926,1.926,0,0,0-1.322.487Z",
    transform: "translate(-206.606 -151.204)",
    fill: "#00c1ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M.919-514.4l-.111-.107a3.007,3.007,0,0,1-.693-2.108v-32.736a2.9,2.9,0,0,1,.8-2.217l18.555,18.584L.919-514.4",
    transform: "translate(14.82 562.983)",
    fill: "url(#a)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.872-172.174l-6.186-6.2,6.185-6.2,7.467,4.249a2.794,2.794,0,0,1,1.57,1.946v0a2.8,2.8,0,0,1-1.57,1.945l-7.467,4.25",
    transform: "translate(33.606 208.372)",
    fill: "url(#b)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.763-263.946a1.924,1.924,0,0,1-1.323-.488h0l18.553-18.583,6.186,6.2L3.441-264.449a3.445,3.445,0,0,1-1.678.5",
    transform: "translate(15.299 313.018)",
    fill: "url(#c)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.745-264.534.19-283.118a1.926,1.926,0,0,1,1.322-.487,3.451,3.451,0,0,1,1.681.5L24.93-270.73l-6.185,6.2",
    transform: "translate(15.547 294.535)",
    fill: "url(#d)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.225-182A1.928,1.928,0,0,1,.9-182.488h0l0,0-.1-.094L.79-182.6l.111-.111a1.923,1.923,0,0,0,1.323.487,3.444,3.444,0,0,0,1.678-.5L25.64-195.094l.139.14-.141.08L3.9-182.5a3.576,3.576,0,0,1-1.54.5q-.068,0-.137,0",
    transform: "translate(14.838 231.292)",
    fill: "url(#e)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M.808-32.979a3.006,3.006,0,0,1-.693-2.108v-.219A3.007,3.007,0,0,0,.808-33.2l.111.107-.111.112",
    transform: "translate(14.82 81.675)",
    fill: "url(#f)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M.781-87.793l-.139-.14,7.467-4.25a2.8,2.8,0,0,0,1.57-1.945,1.86,1.86,0,0,1-.173.774,3.216,3.216,0,0,1-1.4,1.39L.781-87.793",
    transform: "translate(39.836 124.13)",
    fill: "url(#g)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67-88.349A2.794,2.794,0,0,0,8.1-90.3L.633-94.544l.139-.14h0L8.1-90.514a2.634,2.634,0,0,1,1.57,2.165",
    transform: "translate(39.844 118.35)",
    fill: "url(#h)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M.115-32.431v-.229c0-.083,0-.163.006-.242v0a.01.01,0,0,1,0,0v-.009a2.861,2.861,0,0,1,.686-1.84l.109.11a2.9,2.9,0,0,0-.8,2.217",
    transform: "translate(14.82 46.065)",
    fill: "url(#i)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.638-181.808,3.9-194.179a3.451,3.451,0,0,0-1.681-.5A1.926,1.926,0,0,0,.9-194.2l-.109-.11q.051-.054.107-.1l0,0a1.925,1.925,0,0,1,1.31-.488h.011a3.45,3.45,0,0,1,1.681.5l21.877,12.45h0l-.139.14",
    transform: "translate(14.839 205.614)",
    fill: "url(#j)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.0fb16db2de1365b4cd0d7e3f9ba4eb1b.svg";
export { ForwardRef as ReactComponent };